import { NiceModalHandler } from '@ebay/nice-modal-react';

import Button from '@/components/button';

import styles from './styles.module.less';

const HintModal = (modal: NiceModalHandler, onClose, innerProps) => {
  const { content, cb, btn } = innerProps;
  return (
    <div className={styles.container}>
      <div className={styles.text}>{content}</div>
      <Button
        className={styles.btn}
        onClick={() => {
          onClose();
          if (cb) {
            cb();
          }
        }}
      >
        {btn || 'OK'}
      </Button>
    </div>
  );
};

export default HintModal;
